import { map, assign } from 'lodash';

/**
 *
 * @param folder Object a row in the folders table
 * @constructor
 */
export class Folder {
  name: string;
  id: string;
  parentId: string;

  static get DEFAULT_CHAT_FOLDER_ID() {
    return '1131837955423461';
  }

  static get DEFAULT_EMAIL_FOLDER_ID() {
    return '1131837791010957';
  }

  static get TYPES() {
    return {
      contacts: 2,
      tickets: 3,
      email: 4,
      chat: 5,
      reports: 7,
      chatCannedMessages: 8,
      emailCannedMessages: 9,
      calls: 50,
      visits: 60,
      sms: 73,
      twitter: 82
    };
  }

  static get DEFAULT_CHAT_FOLDER() {
    return new Folder({
      name: 'Chats',
      id: Folder.DEFAULT_CHAT_FOLDER_ID,
      parentId: null
    });
  }

  static get DEFAULT_EMAIL_FOLDER() {
    return new Folder({
      name: 'Emails',
      id: Folder.DEFAULT_EMAIL_FOLDER_ID,
      parentId: null
    });
  }

  static comparator(folder1, folder2) {
    return folder1.id === folder2.id;
  }

  static wrap(event) {
    return new Folder(event.data);
  }

  static wrapAll(eventList) {
    return map(eventList, Folder.wrap);
  }

  constructor(folder) {
    assign(this, folder);
  }
}

export function factory() {
  return Folder;
}
